/**
 * Video.js plugin "audioDescription"
 *
 * The plugin offers an audio description to a video.
 *
 * @function audioDescription
 * @param
 */

const pluginAudioDescription = videojs => {
  videojs.addLanguage('de', {
    'Audiodescription on': 'Audiodeskription ein',
    'Audiodescription off': 'Audiodeskription aus',
  });

  videojs.registerPlugin('audioDescription', function (player) {
    player.ready(() => {
      // Prevent doubled rendering
      if (player.el_.querySelector('.vjs-audio-description')) return;

      const audioDescription = player.el_.nextElementSibling;
      const video = player.el_.querySelector('video');

      if (audioDescription && audioDescription.nodeName === 'AUDIO') {
        const ratioVolume = 0.3;

        const ADButton = player.controlBar.addChild('button');
        ADButton.controlText(player.localize('Audiodescription on'));
        ADButton.el_.classList.add('vjs-audio-description');
        ADButton.el_.classList.add('vjs-icon-audio-description');

        audioDescription.volume = 0;
        player.volume(ratioVolume);

        const toggleAD = () => {
          if (audioDescription.volume) {
            audioDescription.volume = 0;
            ADButton.controlText(player.localize('Audiodescription on'));
            ADButton.el_.classList.remove('vjs-audio-description-on');
          } else {
            audioDescription.volume = Math.min(video.volume + ratioVolume, 1);
            ADButton.controlText(player.localize('Audiodescription off'));
            ADButton.el_.classList.add('vjs-audio-description-on');
          }
        };

        // toggle "mute" state of audiodescription
        ADButton.on('click', toggleAD);
        ADButton.on('touchend', toggleAD);

        // on play start audiodescription as well
        player.on('play', function () {
          if (audioDescription.paused) {
            audioDescription.play();
          }
        });

        // on pause, pause audiodescription as well
        player.on('pause', function () {
          if (!audioDescription.paused) {
            audioDescription.pause();
          }
        });

        // on ended, pause audiodescription as well
        player.on('ended', function () {
          player.pause();
          audioDescription.pause();
        });

        // sync volume
        player.on('volumechange', function () {
          if (audioDescription.volume) {
            audioDescription.volume = Math.min(video.volume + ratioVolume, 1);
          }
        });

        // sync speed
        player.on('timeupdate', function () {
          if (audioDescription.readyState >= 4) {
            if (
              Math.ceil(audioDescription.currentTime) !==
              Math.ceil(player.currentTime())
            ) {
              audioDescription.currentTime = player.currentTime();
            }
          }
        });
      }
    });
  });
};

export { pluginAudioDescription };
